import * as React from "react";
import i18n from "../../i18n/i18n";
import classNames from "classnames";
import * as FocusTrap from "focus-trap-react";

interface IModalProps {
  children: React.ReactNode;
  title: string;
  isShown: boolean;
  onClose: () => void;
  buttons?: JSX.Element[];
  largeModal?: boolean;
  inheritHeight?: boolean;
}
export default class Modal extends React.Component<IModalProps> {
  constructor(props: IModalProps) {
    super(props);
  }

  public render(): JSX.Element {
    const { title, isShown, onClose, children, buttons, largeModal, inheritHeight } = this.props;

    const classes = classNames({
      modal: true,
      "modal-responsive": largeModal, // If true, the modal will be bigger than the standard BorgerDK modal
    });

    const bodyClasses = classNames({
      "modal-body": true,
      "modal-body-inherit-height": inheritHeight,
    });

    return (
      <div>
        {isShown && <div className="modal-backdrop"></div>}
        {isShown && (
          <FocusTrap>
            <div role="dialog" className={classes}>
              <div className="modal-header">
                <button type="button" className="close" onClick={onClose} data-ui-test="btn-close-modal">
                  &times;<span className="accessibility">{i18n.t("TEXT_CLOSE")}</span>
                </button>
                <h3>{i18n.t(title)}</h3>
              </div>
              <div className={bodyClasses}>{children}</div>
              <div className="modal-footer">
                {buttons || (
                  <button onClick={onClose} className="btn" data-ui-test="dialog-close-btn">
                    {i18n.t("TEXT_CLOSE")}
                  </button>
                )}
              </div>
            </div>
          </FocusTrap>
        )}
      </div>
    );
  }
}
